import { render, staticRenderFns } from "./ProgressTabInstallationPartner.vue?vue&type=template&id=620affcc&scoped=true&"
import script from "./ProgressTabInstallationPartner.vue?vue&type=script&lang=ts&"
export * from "./ProgressTabInstallationPartner.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressTabInstallationPartner.vue?vue&type=style&index=0&id=620affcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620affcc",
  null
  
)

export default component.exports